import {fnLocalizeFilter, ILocale} from "../../../../../../services/localize.service";
import {ICardLimits, ICards} from "../../../../../../services/response.interface";
import {AppDispatch} from "../../../../../../store/store";
import {IColumn} from "../../../../../UI/CustomTable/components/Columns/Columns";
import {ISingleRow} from "../../../../../UI/CustomTable/interface/interface.custom";
import {handleChangeLimitField, handleDeleteLimit} from "../../../utils/local.request.api";
import {checkPermission} from "../../../../../../helpers/permissions";


interface IGetColumnsCard {
    locale: ILocale;
    cards: ICards[];
    limits: ICardLimits[];
    cardId: string;
    dispatch: AppDispatch;
}

export const getColumnsLimits = ({locale, cardId, dispatch, limits}: IGetColumnsCard): IColumn[] => {

    const onChangeField = async ({row}: ISingleRow) => {
        return await handleChangeLimitField({
            row, locale, limits, cardId, dispatch
        });

    };

    const onClickDelete = async ({row}: ISingleRow) => {
        return await handleDeleteLimit({
            row, locale, limits, cardId, dispatch
        });

    };

    return [{
        field: 'typeSchema',
        label: fnLocalizeFilter(locale, '_lang.module.cards.limits.titleSchemaType'),
        formatHeader: 'default',
        cell: {zeroCheckField: 'rest', format: 'default-or-red-zero-field'},
        align: 'center',
        alignData: 'center',
        sortable: false,
        width: 200
    }, {
        field: 'purses',
        label: fnLocalizeFilter(locale, '_lang.module.cards.limits.titlePurses'),
        formatHeader: 'default',
        cell: {zeroCheckField: 'rest', format: 'default-or-red-zero-field'},
        align: 'center',
        alignData: 'center',
        sortable: false,
        width: 200
    }, {
        field: 'type',
        label: fnLocalizeFilter(locale, '_lang.module.cards.limits.titleType'),
        formatHeader: 'default',
        cell: {zeroCheckField: 'rest', format: 'default-or-red-zero-field'},
        align: 'center',
        alignData: 'center',
        sortable: false,
        width: 200
    }, {
        field: 'qtyLimit',
        label: fnLocalizeFilter(locale, '_lang.module.cards.limits.titleLimitAmount'),
        formatHeader: 'default',
        cell: {
            zeroCheckField: 'rest',
            format: checkPermission({permissionName: 'Limits'}) > 1 ? 'text-edit-limits-or-red-zero-field' : 'default-or-red-zero-field',
            onChangeField
        },
        align: 'center',
        alignData: 'center',
        width: 130,
        sortable: false
    }, {
        field: 'balance',
        label: fnLocalizeFilter(locale, '_lang.module.cards.limits.titleBalance'),
        formatHeader: 'default',
        cell: {zeroCheckField: 'rest', format: 'default-or-red-zero-field'},
        align: 'center',
        alignData: 'center',
        width: 130,
        sortable: false
    }, {
        field: 'rest',
        label: fnLocalizeFilter(locale, '_lang.module.cards.limits.titleRest'),
        formatHeader: 'default',
        cell: {
            zeroCheckField: 'rest', format: 'default-or-red-zero-field'
        },
        align: 'center',
        alignData: 'center',
        width: 130,
        sortable: false
    }, {
        field: 'btnAccount', label: '', width: 130, formatHeader: 'default', cell: {
            format: checkPermission({permissionName: 'Limits'}) > 1 ? 'icon-delete' : 'empty',
            onClickDelete,
            labelConfirm: fnLocalizeFilter(locale, '_lang.module.common.modal.labelConfirmation')
        }, align: 'center', alignData: 'center'
    }

    ];
};

export const getColumnsLimitsOld = ({locale, cardId, dispatch, limits}: IGetColumnsCard): IColumn[] => {

    const onChangeField = async ({row}: ISingleRow) => {
        return await handleChangeLimitField({
            row, locale, limits, cardId, dispatch
        });

    };

    const onClickDelete = async ({row}: ISingleRow) => {
        return await handleDeleteLimit({
            row, locale, limits, cardId, dispatch
        });

    };

    return [{
        field: 'listPurses',
        label: fnLocalizeFilter(locale, '_lang.module.cards.limits.titlePurses'),
        formatHeader: 'default',
        cell: {format: 'default'},
        align: 'center',
        alignData: 'center',
        sortable: true,
        width: 200
    }, {
        field: 'moneyOnce',
        label: fnLocalizeFilter(locale, '_lang.module.cards.limits.titleMoneyByOnce'),
        formatHeader: 'text-edit-limits',
        cell: {
            format: checkPermission({permissionName: 'Limits'}) > 1 ? 'text-edit-limits' : 'default', onChangeField
        },
        align: 'center',
        alignData: 'center',
        width: 130,
        sortable: true
    }, {
        field: 'qtyOnce',
        label: fnLocalizeFilter(locale, '_lang.module.cards.limits.titleQtyByOnce'),
        formatHeader: 'text-edit-limits',
        cell: {
            format: checkPermission({permissionName: 'Limits'}) > 1 ? 'text-edit-limits' : 'default', onChangeField
        },
        align: 'center',
        alignData: 'center',
        width: 130,
        sortable: true
    }, {
        field: 'moneyDay',
        label: fnLocalizeFilter(locale, '_lang.module.cards.limits.titleMoneyByDay'),
        formatHeader: 'text-edit-limits',
        cell: {
            format: checkPermission({permissionName: 'Limits'}) > 1 ? 'text-edit-limits' : 'default', onChangeField
        },
        align: 'center',
        alignData: 'center',
        width: 130,
        sortable: true
    }, {
        field: 'qtyDay',
        label: fnLocalizeFilter(locale, '_lang.module.cards.limits.titleQtyByDay'),
        formatHeader: 'text-edit-limits',
        cell: {
            format: checkPermission({permissionName: 'Limits'}) > 1 ? 'text-edit-limits' : 'default', onChangeField
        },
        align: 'center',
        alignData: 'center',
        width: 130,
        sortable: true
    }, {
        field: 'moneyWeek',
        label: fnLocalizeFilter(locale, '_lang.module.cards.limits.titleMoneyByWeek'),
        formatHeader: 'text-edit-limits',
        cell: {
            format: checkPermission({permissionName: 'Limits'}) > 1 ? 'text-edit-limits' : 'default', onChangeField
        },
        align: 'center',
        alignData: 'center',
        width: 130,
        sortable: true
    }, {
        field: 'qtyWeek',
        label: fnLocalizeFilter(locale, '_lang.module.cards.limits.titleQtyByWeek'),
        formatHeader: 'text-edit-limits',
        cell: {
            format: checkPermission({permissionName: 'Limits'}) > 1 ? 'text-edit-limits' : 'default', onChangeField
        },
        align: 'center',
        alignData: 'center',
        width: 130,
        sortable: true
    }, {
        field: 'moneyMonth',
        label: fnLocalizeFilter(locale, '_lang.module.cards.limits.titleMoneyByMonth'),
        formatHeader: 'text-edit-limits',
        cell: {
            format: checkPermission({permissionName: 'Limits'}) > 1 ? 'text-edit-limits' : 'default', onChangeField
        },
        align: 'center',
        alignData: 'center',
        width: 130,
        sortable: true
    }, {
        field: 'qtyMonth',
        label: fnLocalizeFilter(locale, '_lang.module.cards.limits.titleQtyByMonth'),
        formatHeader: 'text-edit-limits',
        cell: {
            format: checkPermission({permissionName: 'Limits'}) > 1 ? 'text-edit-limits' : 'default', onChangeField
        },
        align: 'center',
        alignData: 'center',
        width: 130,
        sortable: true
    }, {
        field: 'moneyOutOfTime',
        label: fnLocalizeFilter(locale, '_lang.module.cards.limits.titleMoneyOutOfTime'),
        formatHeader: 'text-edit-limits',
        cell: {format: 'text-or-empty-cell'},
        align: 'center',
        alignData: 'center',
        width: 130,
        sortable: true
    }, {
        field: 'qtyOutOfTime',
        label: fnLocalizeFilter(locale, '_lang.module.cards.limits.titleQtyOutOfTime'),
        formatHeader: 'text-edit-limits',
        cell: {format: 'text-or-empty-cell'},
        align: 'center',
        alignData: 'center',
        width: 130,
        sortable: true
    },

        {
            field: 'balance',
            label: fnLocalizeFilter(locale, '_lang.module.cards.limits.titleBalance'),
            formatHeader: 'default',
            cell: {
                format: 'default'
            },
            align: 'center',
            alignData: 'center',
            width: 130,
            sortable: true
        }, {
            field: 'btnAccount', label: '', width: 130, formatHeader: 'default', cell: {
                format: checkPermission({permissionName: 'Limits'}) > 1 ? 'icon-delete' : 'empty',
                onClickDelete,
                labelConfirm: fnLocalizeFilter(locale, '_lang.module.common.modal.labelConfirmation')
            }, align: 'center', alignData: 'center'
        }

    ];
};
